import BookingFormJob, { FormData as FormDataExport } from './BookingFormJob';

export type FormData = FormDataExport;
export default BookingFormJob;
